import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@tiney/web-kit/src/theme/global.css";

import posthog from "posthog-js";
import { clearPersistedIdentity, persistIdentity, pfffIdentity } from "src/utils/pfff";

export const onClientEntry = () => {

  let pfffId = null;

  try {
    pfffId = pfffIdentity();
  } catch (e) {
    // If PFFF fails, PostHog will fall back to default identity.
  }

  const bootstrapConfig = { featureFlags: {} };
  if (pfffId) bootstrapConfig.distinctID = pfffId;

  posthog.init('phc_ETtVUGNX9CitTbwaNis5mnSmRnv6cG8Sg6chZyWZof8', { // exposed in browser - not a secret
    api_host: 'https://start.tiney.co/ph',
    ui_host: 'https://eu.posthog.com',
    defaults: '2025-05-24',
    bootstrap: bootstrapConfig,
  });

  window.posthog = posthog;

  function syncPostHogWithTermly() {
    const consent = window.Termly?.getConsentState?.();
    if (!consent || !window.posthog) return;

    if (consent.analytics === true) {
      persistIdentity();
      window.posthog.opt_in_capturing();
    } else if (consent.analytics === false) {
      clearPersistedIdentity();
      window.posthog.set_config({ persistence: 'memory' });
      window.posthog.opt_out_capturing();
    }
  }

  function onTermlyLoaded() {
    syncPostHogWithTermly();
    window.Termly.on('initialized', syncPostHogWithTermly);
    window.Termly.on('consent', syncPostHogWithTermly);
  }

  // Check if Termly is already loaded, or poll until it is
  let attempts = 0;
  const maxAttempts = 200; // 10 seconds

  const interval = setInterval(() => {
    attempts++;
    if (window.Termly) {
      clearInterval(interval);
      onTermlyLoaded();
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
      console.warn('Termly failed to load after 10 seconds.');
    }
  }, 50);
};
